import { createFileRoute } from "@tanstack/react-router";
import TmsForBipolarDepression from "@/pages/TmsForBipolarDepression";
export const Route = createFileRoute("/tms-for-bipolar-depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS For Bipolar Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS for bipolar depression in Coral Springs, FL. Learn about the evidence, safety, and when TMS may be considered for bipolar disorder Free consultation.",
        },
        {
          property: "og:title",
          content: "TMS For Bipolar Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS for bipolar depression in Coral Springs, FL. Learn about the evidence, safety, and when TMS may be considered for bipolar disorder Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-for-bipolar-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-for-bipolar-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsForBipolarDepression />;
}
